'use strict';
require('../../modules/es.array.filter');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'filter');
